import type {ConnectElementConfig} from '../ConnectElementList';

export const editDisabledParameter = 'edit-disabled';
export const payoutSettingsParameter = 'payoutSettings';

export const EditPayoutScheduleConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "EditPayoutSchedule" */
      '../../../components/Account/PayoutInformation/PayoutSchedule/EditPayoutScheduleOverlay'
    ),
  enabledKey: 'payouts',
  releaseState: 'internal',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description: "Payout component's entry point to edit payout schedule",
  friendlyName: 'Payouts entry point: edit payout schedule',
  htmlAttributes: {
    [editDisabledParameter]: {
      isInternal: true,
    },
  },
  customHtmlElementMethods: {
    setPayoutSettings: {
      type: 'SupplementalObject',
      objectToSet: payoutSettingsParameter,
      isInternal: true,
      description: 'Sets the payout settings of the account',
    },
    setEditDisabled: {
      type: 'AttributeSettingMethod',
      attribute: editDisabledParameter,
      isInternal: true,
      description:
        'Set whether edit payout schedule is disabled for the account',
    },
  },
};
